import "./App.css";
import LandingPage from "./pages/LandingPage";
import { Route, Routes } from "react-router-dom";
import KycPage from "./pages/KycPage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="verify/:msisdn" element={<KycPage />} />
      </Routes>
    </>
  );
}

export default App;
